<template>
  <div class="main-dashboard">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="12">
              
              <div class="card card-custom card-compact">
                <div class="card-header card-header-nobdr">
                  <div class="card-title">
                    <h3 class="card-label">Analytics</h3>
                    <span class="sub-title">Overview of Latest Week</span>
                  </div>
                  <div class="header-aside-content" id="dashboard-filter">
                    <div class="aside-content">
                      <merchant-filter
                        v-if="currentUser.role ==='SUPER_ADMIN' || currentUser.role ==='ADMIN_USER'"
                        :items="merchantList"
                        @merchantSelected="merchantDashaboard"
                      />
                    </div>
                    <div class="aside-content">
                      <v-select
                        :items="rangeSelector"
                        item-text="text"
                        item-value="value"
                        @change="getDashboardData"
                        v-model="analyticSelector"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="amount-info">
                        <div class="amount-info-wrap">
                          <div class="amount-info-content">
                            <h1 class="info-main-title">
                              <small>Rs</small>
                              {{ this.dashboardData.totalPaidAmount | toFixedNumber }}
                            </h1>
                            <h6 class="font-light text-muted">Total Amount Paid</h6>
                          </div>
                          <div class="amount-info-content">
                            <h4 class="info-main-title">
                              <!-- Cannot say Rs here as currencies other than NPR will be used -->
                              <small>Rs</small>
                              {{ this.dashboardData.totalSentAmount | toFixedNumber }}
                            </h4>
                            <h6 class="font-light text-muted">Total Sent Amount</h6>
                          </div>
                        </div>
                        <a class="btn btn-primary">Last Week Summary</a>
                      </div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div class="main-chart-wrap">
                        <AreaChart
                          :paymentLabels="paymentLabels"
                          :paymentData="paymentData"
                        />
                        <!-- <LineChart /> -->
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div class="card-body pb-4 pt-3 mdi-bdr-top" id="link-count-description">
                  <v-row>
                    <div class="col-lg-3 col-md-6 pl-0 pr-0">
                      <div class="feature-chart">
                        <Donough
                          ref="skills_chart"
                          :chart-data="chartData"
                          :options="options"
                        />
                        <div class="feature-chart-label">
                          <span
                            >Total Links
                            <span class="d-block label-title">{{
                              this.dashboardData.totalClicked +
                                this.dashboardData.totalIgnored +
                                this.dashboardData.totalPaid
                            }}</span></span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                      <div class="d-flex align-items-center feature-aside-box">
                        <div class="mr-2 feature-icon">
                          <span class="icon-wrap">
                            <v-icon size="50px" color="#11cdef"
                              >mdi-text-box-check-outline</v-icon
                            >
                          </span>
                        </div>
                        <div class="feature-info">
                          <span>Total Paid</span>
                          <h3>{{ this.dashboardData.totalPaid }}</h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                      <div class="d-flex align-items-center feature-aside-box">
                        <div class="mr-2 feature-icon">
                          <span class="icon-wrap">
                            <v-icon size="50px" color="#525f7f"
                              >mdi-database-minus</v-icon
                            >
                          </span>
                        </div>
                        <div class="feature-info">
                          <span>Total Ignored</span>
                          <h3>{{ this.dashboardData.totalIgnored }}</h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                      <div class="d-flex align-items-center feature-aside-box">
                        <div class="mr-2 feature-icon">
                          <span class="icon-wrap">
                            <v-icon color="#eb7f7f" size="60px"
                              >mdi-gesture-tap</v-icon
                            >
                          </span>
                        </div>
                        <div class="feature-info">
                          <span>Total Clicked</span>
                          <h3>{{ this.dashboardData.totalClicked }}</h3>
                        </div>
                      </div>
                    </div>
                  </v-row>
                </div>
              </div>
              <!-- <div class="card-legend main-dashboard-wrap">
                <v-row>
                  <v-col cols="12">
                    <v-toolbar-title class="font-weight-bold color-white heading-content">
                      Dashboard Category
                    </v-toolbar-title>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <v-card
                      max-width="400"
                      class="bg-light-warning"
                    >
                      <div class="feature-body">
                        <div class="feature-icon">
                          <v-icon
                            size="45px"
                            color="orange darken-2"
                          >
                            mdi-handshake
                          </v-icon>
                        </div>
                        <div class="feature-title display-2 font-weight-bold orange--text">
                          InstaBuy
                        </div>
                      </div>
                      <v-card-actions>
                        <v-btn
                          color="orange"
                          text
                          @click="openPage('Insta Buy')"
                        >
                          Explore
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <v-card
                      max-width="400"
                      class="bg-light-primary"
                    >
                      <div class="feature-body">
                        <div class="feature-icon">
                          <v-icon
                            color="blue"
                            size="45px"
                          >
                            mdi-qrcode
                          </v-icon>
                        </div>
                        <div class="feature-title display-2 font-weight-bold blue--text">
                          QR Request
                        </div>
                      </div>
                      <v-card-actions>
                        <v-btn
                          color="blue"
                          text
                          @click="openPage('Qr Request')"
                        >
                          Explore
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </div> -->
            </v-col>
            <v-col cols="12" md="12">
              <div class="card card-custom card-compact">
                <div class="card-header card-header-nobdr">
                  <div class="card-title">
                    <h3 class="card-label">Payment Insights</h3>
                    <span class="sub-title">Showing all methods of payments</span>
                  </div>
                  <div class="header-aside-content">
                    <div class="aside-content">
                      <merchant-filter
                        :items="merchantList"
                        @merchantSelected="merchantPayment"
                        v-if="currentUser.role ==='SUPER_ADMIN' || currentUser.role ==='ADMIN_USER'"
                      />
                    </div>
                    <div class="aside-content">
                      <v-select
                        :items="rangeSelector"
                        item-text="text"
                        item-value="value"
                        v-model="modeRangeSelected"
                        @change="getTransactionDetail"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <!-- <Donough
                    ref="skills_chart"
                    :chart-data="chartData"
                    :options="options"
                  /> -->
                  <v-row no-gutters>
                    <v-col cols="12" no-gutters md="5">
                      <PieChart :chartData="pieChartData" ref="PieChart" />
                    </v-col>
                    <v-col cols="12" no-gutters md="7">
                      <v-simple-table class="custom-simple-table">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-capitalize">
                                Payment Mode
                              </th>
                              <th class="text-left text-capitalize">
                                No of Transaction
                              </th>
                              <th class="text-left text-capitalize">
                                Overall %
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in modeWise" :key="item.paymentMode">
                              <td>
                                <span class="color" :class="item.paymentMode"></span
                                >{{ item.paymentMode }}
                              </td>
                              <td>{{ item.count }}</td>
                              <td>{{ item.percent | toFixedNum }} %</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <!-- <div class="card-legend main-dashboard-wrap mb-5">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-toolbar-title class="color-white heading-content">
                      Analytics
                    </v-toolbar-title>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-card
                      max-width="400"
                      class="bg-light-warning"
                    >
                      <div class="feature-body">
                        
                        <div class="feature-title display-2 font-weight-bold orange--text">
                          Total Sent Amount
                        </div>
                      </div>
                      
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-card
                      max-width="400"
                      class="bg-light-primary"
                    >
                      <div class="feature-body">
                        
                        <div class="feature-title display-2 font-weight-bold blue--text">
                          Total Amount Paid
                        </div>
                      </div>
                    
                    </v-card>
                  </v-col>
                </v-row>
              </div> -->
              <!-- <div class="card card-custom">
                <div class="card-body">
                  <PieChart />
                </div>
              </div> -->
            </v-col>
          </v-row>
        </v-container>
  </div>
</template>

<script>



import Promise from "../../../lib/mixins/ExtendedPromises";
import Report from "../../../repositories/reportController";

import AreaChart from "@/views/dashboard/component/charts/AreaChart";
import PieChart from "@/views/dashboard/component/charts/PieChart";
import LineChart from "@/views/dashboard/component/charts/LineChart";
import Donough from "@/views/dashboard/component/charts/Donough";

import CheckMark from "@/views/dashboard/component/CheckMark";

import MerchantFilter from "@/views/dashboard/component/MerchantFilter";

import moment from "moment";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    animateRotate: false
  }
};
export default {
  name: "MainDashboard",
  mixins: [Promise],
  components: {
    AreaChart,
    PieChart,
    LineChart,
    Donough,
    MerchantFilter,
    CheckMark
  },
  data() {
    return {
      
      paymentLabels: [],
      paymentData: [],
      analyticSelector: "MONTH",
      rangeSelector: [
        { value: "WEEK", text: "Week" },
        { value: "MONTH", text: "Month" }
      ],
      modeRangeSelected: "MONTH",
      options: {
        legend: {
          display: false
        },
        cutoutPercentage: 70,
        responsive: true,
        maintainAspectRatio: false
      },
      paymentInsight: [
        {
          mode: "Card",
          transaction: 50,
          overall: 40
        },
        {
          mode: "Mobank",
          transaction: 30,
          overall: 20
        },
        {
          mode: "E-bank",
          transaction: 30,
          overall: 10
        }
      ],
      chartData: {
        labels: ["paid", "ignored", "clicked"],
        datasets: [
          {
            backgroundColor: ["#11cdef", "#525f7f", "#eb7f7f"],
            data: [0, 0, 100]
          }
        ]
      },
      modeWise: [],
      modeWiseGraph: {},
      pieChartData: [40, 20, 10],
      dashboardData: {},
      merchantList: [],
      selectedDashboardMerchant: {},
      selectedPaymentMerchant: {},
      currentUser: ''
    };
  },
  filters: {
    toFixedNumber (value) {
      if (!value) return ''
      return Number(value.toFixed(2))
    }
  },
  created () {
    this.currentUser =  this.$store.getters.currentUser;
  },
  mounted() {
    this.getTransactionDetail();
    this.getDashboardData();
    this.getMercahantList();
  },
  methods: {
    
    getRequestParams(type, merchantId) {
      let params = {};
      if (type) {
        params["type"] = type;
      }
      if (merchantId) {
        params["merchantId"] = merchantId;
      }

      return params;
    },
    getMercahantList() {
      const operation = this.response(Report.getAllMerchants());
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.merchantList = response.data;
          }
        })
        .catch(err => {
  
          // if (err.data.status === 403) {
          //   this.$toasted.show("Unauthorized User Please Login");
          // }
        });
    },
    merchantDashaboard(merchant) {
      this.selectedDashboardMerchant = merchant;
      this.getDashboardData();
    },
    merchantPayment(merchant) {
      this.selectedPaymentMerchant = merchant;
      this.getTransactionDetail();
    },
    openPage(param) {
      this.$router.push({ name: `${param}` });
    },
    getIsoDate(val) {
      const event = new Date(val);
      let isoDate = event.toISOString();
      return isoDate;
    },
    setDashboardChart(data) {
      let dateCollection = data.dates;
      this.paymentLabels = dateCollection.sort(
        (a, b) =>
          new moment(a).format("YYYYMMDD") - new moment(b).format("YYYYMMDD")
      );
      this.paymentLabels = this.paymentLabels.map(date =>
        moment(date).format("MMM Do")
      );
      this.paymentData = data.paymentAmount;
    },
    getDashboardData() {
      const params = this.getRequestParams(
        this.analyticSelector,
        this.selectedDashboardMerchant.merchantId
      );

      const operation = this.response(Report.getDashBoardResource(params));
      operation
        .then(response => {
          if (operation.isFulfilled()) {

            this.dashboardData = response.data;
            this.setDashboardChart(this.dashboardData);

            let total =
              Number(this.dashboardData.totalClicked) +
              Number(this.dashboardData.totalIgnored) +
              Number(this.dashboardData.totalPaid);
            let chartPercent = [];

            let percent =
              (Number(this.dashboardData.totalPaid) / Number(total)) * 100;
            chartPercent.push(percent.toFixed(2));
            percent =
              (Number(this.dashboardData.totalIgnored) / Number(total)) * 100;
            chartPercent.push(percent.toFixed(2));
            percent =
              (Number(this.dashboardData.totalClicked) / Number(total)) * 100;
            chartPercent.push(percent.toFixed(2));
            this.chartData = {
              labels: ["paid", "ignored", "clicked"],
              datasets: [
                {
                  backgroundColor: ["#11cdef", "#525f7f", "#eb7f7f"],
                  data: chartPercent
                }
              ]
            };
          }
        })
        .catch(err => {
          // if (err.data.status === 403) {
          //   this.$toasted.show("Unauthorized User Please Login");
          // }
        });
    },
    getTransactionDetail() {
      const params = this.getRequestParams(
        this.modeRangeSelected,
        this.selectedPaymentMerchant.merchantId
      );
      const operation = this.response(Report.fetchPaymentModeDetail(params));
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.modeWise = response.data;
            // let total =
            this.filterModeWiseData();
          }
        })
        .catch(err => {
          // if (err.data.status === 403) {
          //   this.$toasted.show("Unauthorized User Please Login");
          // }
        });
    },
    filterModeWiseData() {
      this.pieChartData = [];
      let total = 0;
      this.modeWise.forEach(item => (total = total + Number(item.count)));
      this.modeWise = this.modeWise.map(item => {
        let percent = (Number(item.count) / Number(total)) * 100;
        this.pieChartData.push(percent.toFixed(2));
        return { ...item, percent: percent };
      });
    }
  }
};
</script>

<style lang="scss">
.card-legend {
  background: white;
  box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  border-radius: 5px;
}
.main-dashboard-wrap {
  padding: 0 24px;
  position: relative;
  z-index: 1;
  &:before {
    content: "";
    background: #e53135;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 135px;
    z-index: -1;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }
}
.v-card {
  margin-top: 0;
}
.heading-content {
  color: white;
}
.bg-light-warning {
  background-color: #fff4de !important;
}
.feature-body {
  padding: 1rem;
  .feature-icon {
    margin-bottom: 1rem;
  }
}
.bg-light-primary {
  background-color: #e1f0ff !important;
}
.bg-light-danger {
  background-color: #ffe2e5 !important;
}
.bg-light-success {
  background-color: #c9f7f5 !important;
}
.bg-light-blue2 {
  background-color: #deffef !important;
}
.bg-light-purple {
  background-color: #e6dcee !important;
}
.feature-icon {
  min-height: 45px;
  .img-icon {
    img {
      width: 40px;
    }
  }
}
.blue2--text {
  color: #00e676 !important;
}
</style>
